import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import './App.css';
import { Outlet } from "react-router-dom";
import {useAuthContext} from './context/AuthContext';
import UserService from './services/User.service';
import Header from './Header/Header';
// import NotificationService from './services/Notification.service';

function App() {
  
  const dispatch = useDispatch();
  const auth = useAuthContext();

  useEffect(() => {
    if(auth.token) {
      UserService.getUser(dispatch);
    }
    // NotificationService.add({type: 'success', message: 'Hello Wolrd', delay: 10000});
  }, []);

  return (
    <div className="App">
      <div className="wallpaper"></div>
      <main className="App-main">
        <Outlet />
      </main>
      <footer className="App-footer">Copyright 2026</footer>
      <Header></Header>
      <div id="notifications"></div>
    </div>
  );
}

export default App;
